import { render, staticRenderFns } from "./SettingsNew.vue?vue&type=template&id=fff3700a&"
import script from "./SettingsNew.vue?vue&type=script&lang=js&"
export * from "./SettingsNew.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports